import type { API } from 'chessboard/api/config/types';

/**
 * Create the undo method.
 */
export function createUndo(context: API.Context) {
  /**
   * Undo the last move.
   */
  return function undo(): API.Response {
    const { api } = context;

    const selectedNode = api.getSelectedNode();

    if (!selectedNode) {
      return null;
    }

    return api.deletePosition(selectedNode.ids.move, selectedNode.ids.line);
  };
}
